window._ = require("lodash");
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;

window.app = window.app || {};
app.locale = document.querySelector("html").getAttribute("lang");
app.errors = [];
app.success = [];

try {
  window.$ = window.jQuery = require("jquery");
} catch (e) {}

// bootstrap
import "./polyfill";
import "./watermark";
import "./browse-happy";

// controllers
import "../controllers";
